import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  lightcastToken: null,
  lightcastTokenExpiresAt: null,
  id: null,
  firstName: null,
  lastName: null,
  isProfileComplete: false,
  isWelcomeSeen: false,
  type: null,
  subscription: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token;
      state.id = action.payload.id;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.isProfileComplete = action.payload.isProfileComplete;
      state.isWelcomeSeen = action.payload.isWelcomeSeen || false;
      state.type = action.payload.type;
      state.subscription = action.payload.subscription;
      state.email = action.payload.email
    },
    logout: () => {
      return initialState;
    },
    setFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setProfileComplete: (state, action) => {
      state.isProfileComplete = action.payload;
    },
    setWelcomeSeen: (state, action) => {
      state.isWelcomeSeen = action.payload;
    },
    setLightcastToken: (state, action) => {
      state.lightcastToken = action.payload.token;
      state.lightcastTokenExpiresAt = action.payload.expiresAt;
    },
    clearLightcastToken: (state) => {
      state.lightcastToken = null;
      state.lightcastTokenExpiresAt = null;
    },
    setSubscription: (state, action) => {
      state.subscription = action.payload;
    },
  },
});

export const {
  login,
  logout,
  setProfileComplete,
  setWelcomeSeen,
  setLightcastToken,
  clearLightcastToken,
  setFirstName,
  setSubscription,
} = authSlice.actions;
export default authSlice.reducer;
